module.exports = __webpack_public_path__ + "static/image/history/pc/202603_1.ver2_0_2.jpg?2a0a3014";